import { useState } from 'react';

type PatchFn<T> = (old: T) => T;

/**
 * 创建Partial State
 * @param initialState {object} 初始状态
 */
export function usePartialState<T extends Record<string, unknown>>(initialState: T) {
  const [state, setState] = useState(initialState);

  const updateState = (patch: Partial<T> | PatchFn<T>) => {
    if (typeof patch === 'function') {
      setState((prevState) => patch(prevState));
    }
    if (typeof patch === 'object') {
      // prettier-ignore
      setState(prevState => ({ ...prevState, ...patch }));
    }
  };
  return [state, updateState] as const;
}
